class QuestionForm
{
    constructor(el, config)
    {
        this.config = config;
        this.el = el;
        this.form = this.el.querySelector('form');

        this.form.addEventListener('submit', (e) => {
            e.preventDefault();
            this.submit();
        });

        this.el.addEventListener('click', (e) => {
            if (e.target.dataset.action === 'close-result') {
                e.preventDefault();
                this.hideResult();
            }
        }, { capture: true });

        //this.showLoader();
        //this.showResult(true, 'Thanks for submitting your question!');
    }

    showLoader()
    {
        this.hideResult();

        if (!this.loader) {
            this.loader = document.createElement('div');
            this.loader.classList.add('loader', 'overlay');
            this.loader.innerHTML = '<div class="spinner"></div> <div class="text">Submitting...</div>';
            this.el.append(this.loader);
        }

        this.loader.classList.add('active');
    }

    hideLoader()
    {
        if (!this.loader) {
            return;
        }

        this.loader.classList.remove('active');
    }

    showResult(success, message)
    {
        this.hideLoader();

        if (!this.result) {
            this.result = document.createElement('div');
            this.result.classList.add('result', 'overlay');
            this.result.innerHTML = '<div class="icon"></div> <div class="text"></div> <div class="actions"> <button class="btn btn-lg" data-action="close-result">Close</button></div>';
            this.el.append(this.result);
        }

        this.result.querySelector('.icon').innerHTML = success ? '<i class="fa fa-check"></i>' : '<i class="fa fa-remove"></i>';
        this.result.querySelector('.text').innerHTML = message;
        this.result.querySelector('[data-action="close-result"]').innerHTML = success ? 'Submit another' : 'Close';
        this.result.classList.remove(success ? 'error' : 'success')
        this.result.classList.add('active', success ? 'success' : 'error');
    }

    hideResult()
    {
        if (!this.result) {
            return;
        }

        this.result.classList.remove('active');

        if (this.currentResult && this.currentResult.success) {
            this.form.reset();
            setTimeout(() => this.form.querySelector('[name="question"]').focus(), 50);
        }
    }

    submit() {
        this.showLoader();
        
        return fetch(this.form.action, {
            method: "POST",
            body: new URLSearchParams(new FormData(this.form)),
            headers: {
                "Content-Type": "application/x-www-form-urlencoded"
            }
        })
        .then(response => response.json())
        .then(data => {
            this.currentResult = data;
            this.showResult(data.success, data.message);
        })
        .catch(e => {
            this.showResult(false, 'Sorry, an unknown error ocurred. Please try again');
        });
    }
}

QuestionForm.init = function(config) {
    document.querySelectorAll('.questions').forEach((el) => {
        new QuestionForm(el, config);
    });
}

window.QuestionForm = QuestionForm;

export default QuestionForm;